import React, { useState } from "react";
import UserDropdown from "./UserDropdown";
import Button from "../../components/form/Button";
import { Link, NavLink } from "react-router-dom";
import { classNames } from "../../helpers/classNames";
import logo from "../../assets/images/logo.png";
import Image from "../../components/elements/Image";
import Indentification from "../../components/elements/Indentification";
import { initialsValue } from "../../helpers";

const AdminHeader = ({ profile }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menudata = [
    { _id: 1, icon: "fa-solid fa-house", link: "/", name: "Home" },
    { _id: 2, icon: "fa-solid fa-gauge-high", link: "/", name: "Dashboard" },
    { _id: 3, icon: "fa-solid fa-envelope", link: "/", name: "Email Settings" },
  ];

  const data = {
    image: profile?.image?.url,
    name: profile?.firstName ? profile?.firstName : "Admin",
    email: profile?.email || "admin123@gmail.com",
  };

  return (
    <>
      <header className="relative h-16 z-50 w-full flex py-2 border-t border-shades-05/25">
        <div className="relative flex items-center gap-2 w-full">
          <div className="flex items-center justify-between flex-shrink flex-grow mr-auto">
            <div className="overflow-hidden mr-auto xls:mr-0 w-40">
              <Link to={"/"} className="flex w-full h-full">
                <Image src={logo} alt="" effect={"blur"} classes={"object-cover"} />
              </Link>
            </div>
            <div className="relative z-[1]">
              <div className="relative xls:hidden">
                <Button
                  buttonClasses={"!h-10 md:!h-12 !rounded-lg !px-0 !aspect-square"}
                  buttonHasLink={false}
                  buttonIcon={"fa-regular fa-fw fa-bars text-2xl"}
                  buttonIconPosition={"left"}
                  buttonFunction={() => setMenuOpen(true)}
                />
              </div>
              <div
                className={classNames("fixed top-0 left-0 w-full h-full bg-black/75 z-0 xls:hidden transition-all duration-200", menuOpen ? "opacity-100 visible" : "opacity-0 invisible")}
                onClick={() => setMenuOpen(false)}
              ></div>
              <div
                className={classNames(
                  "fixed top-0 left-0 w-full h-full max-w-80 z-20 bg-white shadow-[-4px_0_20px_rgba(0,0,0,0.15)] xls:relative xls:top-auto xls:left-auto xls:w-auto xls:h-auto xls:max-w-none xls:shadow-none transition-all duration-200",
                  menuOpen ? "" : ""
                )}
              >
                {menudata?.length > 0 && (
                  <nav className="relative flex px-8 py-8 xls:py-0 xls:px-0">
                    <div className="flex flex-col w-full xls:flex-row gap-4 xls:gap-8">
                      {menudata?.map((item, index) => (
                        <NavLink
                          to={item.link}
                          key={index}
                          className={({ isActive }) =>
                            classNames(
                              "relative flex items-center text-xl xls:text-base font-semibold h-10 xls:h-10 text-slate-500 font-Inter",
                              isActive ? "" : ""
                            )
                          }
                        >
                          {item.icon && <i className={`${item.icon} text-base pr-1`}></i>}
                          {item.name}
                        </NavLink>
                      ))}
                    </div>
                  </nav>
                )}
              </div>
            </div>
            {/* <div className="flex items-center gap-2">
              {!data?.image || !!data?.image?.url ? (
                <div className="flex items-center justify-center bg-catskill-white text-hobby rounded-full w-7 md:w-8 h-7 md:h-8">
                  <i className="fa-regular fa-user" />
                </div>
              ) : (
                <Indentification initial={initialsValue(data?.name)} />
              )}
              <div className={`text-sm font-medium text-gable-green whitespace-nowrap truncate`}>{data?.name}</div>
            </div> */}
            <div className="flex-shrink-0 flex items-center gap-1">
              {/* <UserDropdown data={data} xPlacement={"topRight"} /> */}
              <div className="flex items-center">
                <div className="flex items-center gap-2">
                  {!data?.image || !!data?.image?.url ? (
                    <div className="flex items-center justify-center bg-catskill-white text-hobby rounded-full w-7 md:w-8 h-7 md:h-8">
                      <i className="fa-regular fa-user" />
                    </div>
                  ) : (
                    <Indentification initial={initialsValue(data?.name)} />
                  )}
                  <div className={`text-sm font-medium text-gable-green whitespace-nowrap truncate font-Inter lowercase`}>{data?.name}</div>
                </div>
                <div className="text-hobby text-lg font-medium font-Inter"><i className="fa-regular fa-arrow-right-from-arc"></i> Logout</div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default AdminHeader;
